import {
  SUPPORTED_LANGUAGES,
  languageLandingPath,
  type SupportedLanguage,
} from '../data/supportedLanguages';

/** BCP 47 / hreflang codes (Norwegian uses nb). */
export function hreflangCodeForLanguage(language: SupportedLanguage): string {
  if (language.lang === 'no') return 'nb';
  return language.lang;
}

export type HreflangAlternate = {
  hreflang: string;
  href: string;
};

/**
 * Alternates for the language-landing cluster, plus x-default → English.
 */
export function languageLandingHreflangAlternates(
  origin: string
): HreflangAlternate[] {
  const base = origin.replace(/\/$/, '');
  const alternates: HreflangAlternate[] = SUPPORTED_LANGUAGES.map((language) => ({
    hreflang: hreflangCodeForLanguage(language),
    href: `${base}${languageLandingPath(language)}`,
  }));

  const english = SUPPORTED_LANGUAGES.find((l) => l.lang === 'en');
  if (english) {
    alternates.push({
      hreflang: 'x-default',
      href: `${base}${languageLandingPath(english)}`,
    });
  }

  return alternates;
}
